<mat-toolbar color="primary" class="topbar-toolbar">
  <button mat-icon-button class="menu-btn" aria-label="Menu" (click)="onMenuClick()">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="logo" (click)="navegar('/dashboard')">
    <mat-icon class="logo-icon">payment</mat-icon>
    <span class="logo-text">Gestor Cobrança</span>
  </div>
  <span class="spacer"></span>
  
  <!-- Usuário logado e botão sair -->
  <div class="user-section">
    <span class="user-name">{{ usuarioLogado }}</span>
    <button mat-icon-button (click)="logout()" matTooltip="Sair" aria-label="Sair">
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </div>
</mat-toolbar>

